import { accordionAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const config = createMultiStyleConfigHelpers(accordionAnatomy.keys);

const entityDirectory = config.definePartsStyle({
  container: {
    bg: 'entityDirectory.surface',
    border: '1px solid',
    borderColor: 'entityDirectory.border',
    mb: 4,
    _last: { mb: 0 },
  },
  button: {
    bg: 'entityDirectory.raisedSurface',
    fontSize: '15px',
    fontWeight: 'semibold',
    gap: 3,
    lineHeight: '18px',
    px: 5,
    py: '18px',
    _hover: { bg: 'entityDirectory.raisedSurface' },
  },
  panel: {
    borderColor: 'entityDirectory.border',
    borderTopWidth: '1px',
    overflowX: 'auto',
    p: 0,
  },
});

export default config.defineMultiStyleConfig({
  variants: { entityDirectory },
});
